import React from "react";
import SidebarComponents from "../../components/ui/SidebarComponents";
import Header from "../../components/ui/Header";
import VerificationMethod from "../../components/screen/profile/VerificationMethod";
import { SIDEBAR_WIDTH } from "../../components/constants/constant";

const VerificationMethodPage = () => {
  return (
    <div className="">
      <div className="flex">
          <SidebarComponents />       
        <div className={`w-[100%] lg:w-[calc(100%-${SIDEBAR_WIDTH}px)] p-3 overflow-hidden`}>
          <Header />
          <VerificationMethod />
        </div>
      </div>
    </div>
  );
};

export default VerificationMethodPage;
